import './App.css';
import axios from 'axios';
// import RendezvousOnTheRed from './RendezvousOnTheRed/RendezvousOnTheRed';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { Route, Routes } from 'react-router-dom';
import Invoice from './RendezvousOnTheRed/Invoice';
import Tickets from './RendezvousOnTheRed/Tickets';
import ThankYou from './RendezvousOnTheRed/ThankYou';
// import MarketingOpportunities from './RendezvousOnTheRed/Components/MarketingOpportunities/MarketingOpportunities';
// import EventVideos from './RendezvousOnTheRed/EventVideos';
// import HypeVideos from './RendezvousOnTheRed/HypeVideos';
// import Map from './RendezvousOnTheRed/Map';
// import GiveawayEntry from './RendezvousOnTheRed/GiveawayEntry';
// import TVDisplay from './RendezvousOnTheRed/Components/TVDisplay/TVDisplay';
// import FakeOrder from './RendezvousOnTheRed/FakeOrder';
// import ChooseGiveaway from './RendezvousOnTheRed/ChooseGiveaway';
// import CopyableScript from './RendezvousOnTheRed/ToggleTouchDownload';
// import SleepToggleScript from './RendezvousOnTheRed/ToggleScreenSleepDownload';
// import SurfaceSetUp from './RendezvousOnTheRed/SurfaceSetUp';
// import GiveawayDrawing from './RendezvousOnTheRed/GiveawayDrawing';

function App() {
  if (window.location.host !== 'localhost:3000') {
    axios.defaults.baseURL = 'https://ninja.sportssouth.dev';
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Routes>
        <Route path='/invoice' element={<Invoice />} />
        <Route path='/tickets' element={<Tickets />} />
        <Route path='*' element={<ThankYou />} />
        {/* <Route path='/marketing-opportunities' element={<MarketingOpportunities />} />
        <Route path='/event-videos' element={<EventVideos />} />
        <Route path='/hype-videos' element={<HypeVideos />} />
        <Route path='/map' element={<Map />} />
        <Route path='/giveaway' element={<ChooseGiveaway />} />
        <Route path='/giveaway/:prizeGroup/:prize' element={<GiveawayEntry />} />
        <Route path='/giveawaydrawing' element={<GiveawayDrawing />} />
        <Route path='/tvdisplay/:interval' element={<TVDisplay />} />
        <Route path='/submitorder' element={<FakeOrder />} />
        <Route path='/toggletouch' element={<CopyableScript />} />
        <Route path='/togglesleep' element={<SleepToggleScript />} />
        <Route path='/surface' element={<SurfaceSetUp />} />
        <Route path='/submitorder' element={<FakeOrder />} />
        <Route path='*' element={<RendezvousOnTheRed />} /> */}
      </Routes>
    </LocalizationProvider>
  );
}

export default App;
